module.exports = __webpack_public_path__ + "img/ico-gathering01.9dd11bf4.svg";